export default __webpack_public_path__ + "static/media/flechas.de254833.png";